import React, { useEffect, useState, useRef} from "react";
import Header from "../components/Header";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { BsFillPencilFill} from "react-icons/bs";
import { useAxios } from "../services/useAxios";
import utf8 from "utf8";
import base64 from "base-64";
import {alert, confirm} from "../components/MegConfirmAlert";

export default function ChangeMemberInfo() {
    const navigate = useNavigate();  
    const { t } = useTranslation();
    const {register, handleSubmit, formState, getValues, setValue, getFieldState, watch}= useForm({mode: "onChange"});
    const{errors} = formState;
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    
    console.log(userInfo)

    const smsRecptnAgreAt = useRef()
    const emailRecptnAgreAt = useRef()

    const phoneRegex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
    const [checkMember, setCheckMember] = useState(false);
    const [timer, setTimer] = useState(180);
    const [verificationSent, setVerificationSent] = useState(false);
    const [request] = useAxios();

    const [isModifyPw, setModifyPw] = useState(false);
    const [isModifyNm, setModifyNm] = useState(false);
    const [isModifyEmail, setModifyEmail] = useState(false);
    const [isModifyPhone, setModifyPhone] = useState(false);
    const [data, setData] = useState({});
    
    
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    const onSubmit = async data=> {
        userInfo.smsRecptnAgreAt = smsRecptnAgreAt.current.checked?"Y":"N"
        userInfo.emailRecptnAgreAt = emailRecptnAgreAt.current.checked?"Y":"N"

        if(isModifyNm){
            userInfo.userNm = data.userNm
            userInfo.password = '';
        }
        if(isModifyEmail){
            userInfo.email = data.email
            userInfo.password = '';
        }

        if(isModifyPw){            
            userInfo.password = data.password
            userInfo.newPassword = data.newPassword
            const response = await request.post("/app/member/getCheckUserPwdAPI", {
                userId : userInfo.userId,
                password : userInfo.password
            });
            if(response.data.resultCode === 200){    
                const response2 = await request.post("/app/member/modifyMyInfoAPI", userInfo);
                if(response2.data.resultCode === 200){            
                    console.log("result",response2.data)   
                    alert(response2.data.resultMessage);  
                    setModifyPw(false)  

                }else{
                    alert(response2.data.resultMessage);    
                }             
            }else{
                alert(t(`Message.change_member_info_pw_not_match`))
            }

        }else{

            const response = await request.post("/app/member/modifyMyInfoAPI", userInfo);
            if(response.data.resultCode === 200){            
                alert(response.data.resultMessage);
                localStorage.setItem("accessToken", response.data.result.token.accessToken);
                localStorage.setItem("refreshToken", response.data.result.token.refreshToken);
                let accessToken = response.data.result.token.accessToken;
                let payload = accessToken.substring(accessToken.indexOf(".") + 1, accessToken.lastIndexOf("."));
                let userInfo = utf8.decode(base64.decode(payload));
                localStorage.setItem("user", userInfo);

                setModifyPw(false)
                setModifyNm(false)
                setModifyEmail(false)
                setModifyPhone(false)

            }else{
                alert(response.data.resultMessage);
            }
        }
    }

    const onSubmit2 = async data=> {
        console.log(data)
        const response = await request.post("/app/member/getCheckUserPwdAPI", {
            userId : userInfo.userId,
            password : data.password
        });
        if(response.data.resultCode === 200){    
            console.log("result",response.data)       
            setCheckMember(true)
        }else{
            alert("비밀번호가 일치하지 않습니다.")
        }
       
    }


    const fn_certSend = async () => {
        const  isState  = getFieldState("moblphon")        
        if(!isState.invalid){
            const response = await request.post("/app/member/sendTelnoCertNumAPI", {
                telNo : getValues("moblphon")
            });
            console.log(response.data)
            if(response.data.resultCode === 200){
                setValue("certNum","")
                resendVerification()
                setVerificationSent(true)
            }else{
                alert(response.data.resultMessage);
            }
            
        }
        
    }

    const fn_certNum = async () => {
        const  isState  = getFieldState("certNum")
        console.log(isState)
        console.log("certNum", getValues("certNum"))
        if(!isState.invalid && getValues("certNum")){
            const response = await request.post("/app/member/procTelnoCertNumAPI", {
                telNo : getValues("moblphon"),
                certNum : getValues("certNum")
            });
            console.log(response.data)
            if(response.data.resultCode === 200){  
                localStorage.setItem("accessToken", response.data.result.token.accessToken);
                localStorage.setItem("refreshToken", response.data.result.token.refreshToken);
                let accessToken = response.data.result.token.accessToken;
                let payload = accessToken.substring(accessToken.indexOf(".") + 1, accessToken.lastIndexOf("."));
                let userInfo = utf8.decode(base64.decode(payload));
                localStorage.setItem("user", userInfo);       
                setModifyPhone(false)
                setVerificationSent(false)
            }else{
                alert(response.data.resultMessage);
            }
        }
    }
    
    const fn_changeAgree = async (e,type) => {
        

        const response = await request.post("/app/member/procUserStplatAgreAPI", {
            smsRecptnAgreAt : smsRecptnAgreAt.current.checked?"Y":"N",
            emailRecptnAgreAt :emailRecptnAgreAt.current.checked?"Y":"N"
        });
        console.log(response.data)
        if(response.data.resultCode !== 200){                          
            alert(response.data.resultMessage);
        }
      

    }

    function regPhoneNumber(e) {
        const result = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(-{1,2})$/g, "");
          setValue('moblphon', result, { shouldValidate: true })          
      }


      // 인증번호 재전송 함수
    const resendVerification = () => {
		setTimer(180);
	};
    
	//타이머 함수
	const formatTime = () => {
		const minutes = Math.floor(timer / 60);
		const seconds = timer % 60;
		return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
	};


    const fetchData = async () => {
        const response = await request.post("/app/member/getUserStplatAgreAPI", {});

        if(response.data.resultCode === 200){
            setData(response.data.result);    
            if(smsRecptnAgreAt.current){
                smsRecptnAgreAt.current.checked=response.data.result.smsRecptnAgreAt==="Y"
            }
            if(emailRecptnAgreAt.current){
                emailRecptnAgreAt.current.checked=response.data.result.emailRecptnAgreAt==="Y"            
            }
        }
    };


    useEffect(() => {
        fetchData();
      }, []);

    useEffect(() => {
        if(isModifyNm){
            setValue("userNm",userInfo.userNm)
        }
        if(isModifyEmail){
            setValue("email",userInfo.email)
        }
        if(isModifyPhone){
            setValue("moblphon",userInfo.moblphon)            
        }
        
      }, [isModifyNm, isModifyEmail, isModifyPhone]);


    useEffect(() => {
		let interval;
		if (verificationSent) {
			interval = setInterval(() => {
				setTimer((prevTimer) => {
					if (prevTimer <= 1) {
						clearInterval(interval);
						setVerificationSent(false);
						return 0;
					}
					return prevTimer - 1;
				});
			}, 1000);
		}
 
		return () => clearInterval(interval);
	}, [verificationSent]);

    return (
        <div>
            <Header type="black" handleBack={(e) => navigate("/Mypage") } pageTitle={t(`Message.my_salee_screen_user_info_chg`)}/>
            {(userInfo.crtfcTy === 'D' && checkMember === false)?(
                <div className="checkInfo">
                    <div>
                        <p className="txt">{t(`Message.change_member_info_pw_re_enter`)}</p>
                    </div>
                    
                    <form onSubmit={handleSubmit(onSubmit2)}>
                        <ul className="dfColG20">
                            <li className="idLi">
                                <p>{t(`Message.personal_sign_up_info_input_email`)}</p>
                                <input type="text" maxLength={60}  value={userInfo.userId} disabled/>
                            </li>
                            <li className="pwLi">
                                <p>{t(`Message.personal_sign_up_info_input_action_pwd`)}</p>
                                <input type="password" placeholder="Password" {...register("password", { required:t(`Message.personal_sign_up_info_input_action_pwd_required`), minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                                {errors.password && <p role="alert" className="alertRed">{errors.password.message}</p>}
                            </li>
                        </ul>
                        <button 
                            type="submit" 
                            className="btn44 orgB cFFF mt30"                           
                        >
                            {t(`Message.common_ok`)}
                        </button>
                    </form>
                </div>
            ):(
            <div className="changeInfo">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="dfColG20">

                        {userInfo.crtfcTy === 'D'?(
                            <>
                        <li className="idLi">
                            <p>{t(`Message.personal_sign_up_info_input_email`)}</p>
                            <input type="text" value={userInfo.userId} disabled/>
                        </li>
                        {!isModifyPw?(
                        <>
                        <li className="idLi"> 
                            <div className="cmiSwap dfsb">
                                <p>{t(`Message.change_member_info_change_pw`)}</p>
                                <button type="button" className="btn2424 pen" onClick={(e)=>{setModifyPw(true); setModifyNm(false); setModifyEmail(false); setModifyPhone(false) }}><BsFillPencilFill /></button>
                            </div>
                        </li>
                        </>
                        ):(   
                        <>                                   
                        <li className="idLi">
                            <p>{t(`Message.change_member_info_current_pw`)}</p>
                            <input type="password" placeholder={t(`Message.change_member_info_enter_pw`)} {...register("password", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                            {errors.password && <p role="alert" className="alertRed">{errors.password.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.change_member_info_new_pw`)}</p>
                            <input type="password" placeholder={t(`Message.change_member_info_enter_chnage_pw`)} {...register("newPassword", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                            {errors.newPassword && <p role="alert" className="alertRed">{errors.newPassword.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.change_member_info_conf_new_pw`)}</p>
                            <div className="dfcsG12 cmiChange">
                                <div className="posiR ">
                                    <input type="password" placeholder={t(`Message.change_member_info_re_enter_change_pw`)} {...register("newPasswordCheck", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." },
                                    validate: (val) => {
                                        if (watch('newPassword') !== val) {
                                        return t(`Message.change_member_info_mismath_pw`);
                                        }
                                    }
                                    })  } />
                                    {errors.newPasswordCheck && <p role="alert" className="alertRed">{errors.newPasswordCheck.message}</p>}
                                    <button type="submit" className="save" >{t(`Message.saveBtn`)}</button>
                                </div>
                                <button type="button" onClick={(e)=>setModifyPw(false)} className="cancel">{t(`Message.common_cancel`)}</button>
                            </div>
                        </li>
                        </>
                        )}
                       
                        </>
                        ):null}
                        <li className="idLi">
                            {!isModifyNm?(
                            <>
                            <p>{t(`Message.social_sign_up_info_input_name`)}</p>
                            <div className="dfcsG6 cmiSwap">
                                <p className="txt">{userInfo.userNm}</p>
                                <button type="button" className="btn2424 pen" onClick={(e)=>{setModifyNm(true); setModifyPw(false); setModifyEmail(false); setModifyPhone(false) }}><BsFillPencilFill /></button>
                            </div>
                            </>
                            ):(                            
                            <div className="dfcsG12 cmiChange">
                                <div className="posiR">
                                    <input type="text" maxLength={50} {...register("userNm", { required: "필수 응답 항목입니다."})} />
                                    {errors.userNm && <p role="alert" className="alertRed">{errors.userNm.message}</p>}
                                    <button type="submit" className="save">{t(`Message.saveBtn`)}</button>
                                </div>
                                <button type="button" onClick={(e)=>setModifyNm(false)} className="cancel">{t(`Message.common_cancel`)}</button>
                            </div> 
                            )}
                        </li>
                        <li className="idLi">
                            {!isModifyEmail?(
                            <>
                            <p>{t(`Message.social_sign_up_info_input_email`)}</p>
                            <div className="dfcsG6 cmiSwap">
                                <p className="txt">{userInfo.email}</p>
                                <button type="button" className="btn2424 pen" onClick={(e)=>{setModifyEmail(true); setModifyPw(false); setModifyNm(false); setModifyPhone(false) }} ><BsFillPencilFill /></button>
                            </div>
                            </>
                            ):(   
                            <div className="dfcsG12 cmiChange">
                                <div className="posiR">
                                    <input type="text" maxLength={60}  placeholder={t(`Message.ordrr_form_hint_email`)} {...register("email", { required: t(`Message.social_sign_up_info_input_email_required`), pattern: {value: emailRegex, message: t(`Message.social_sign_up_info_input_email_invalid`)}})}/>
                                    {errors.email && <p role="alert" className="alertRed">{errors.email.message}</p>}
                                    <button type="submit" className="save">{t(`Message.saveBtn`)}</button>
                                </div>
                                <button type="button" onClick={(e)=>setModifyEmail(false)} className="cancel">{t(`Message.common_cancel`)}</button>
                            </div> 
                             )}
                        </li>
                        <li className="idLi phone">
                            {!isModifyPhone?(
                            <>
                            <p>{t(`Message.ordrr_form_label_mobile`)}</p>
                            <div className="dfcsG6 cmiSwap">
                                <p className="txt">{userInfo.moblphon}</p>
                                <button type="button" onClick={(e)=>{setModifyPhone(true); setModifyPw(false); setModifyNm(false); setModifyEmail(false) }}  className="btn2424 pen"><BsFillPencilFill /></button>
                            </div>
                            </>
                            ):( 
             
                            <div className="cmiChange">
                                <div className="dfcsG8">
                                    <input type="tel" maxLength={13} placeholder={t(`Message.ordrr_form_hint_mobile`)}  readOnly={verificationSent} {...register("moblphon", { onChange: (e) => {regPhoneNumber(e)}, required: t(`Message.ordrr_form_required_mobile`), pattern: {value: phoneRegex, message:"올바른 휴대폰 형식이 아닙니다."}})}/>  
                                    {errors.moblphon && <p role="alert" className="alertRed">{errors.moblphon.message}</p>}
                                    <button type="button" className="btn40 cFFF greenB" onClick={fn_certSend} disabled={verificationSent} >{t(`Message.change_member_info_send_auth_num`)}</button>
                                    <button type="button" onClick={(e)=>{setModifyPhone(false); setVerificationSent(false);}}  className="cancel">{t(`Message.common_cancel`)}</button>
                                </div>
                                {verificationSent?(
                                <div className="dfcsG12 mt4">
                                    <input type="tel" maxLength={6} {...register("certNum", { required: "필수 응답 항목입니다.",  minLength: {value:6 , message:"최소 6자리 이상 입력해주세요."}})}  placeholder="인증번호를 입력해주세요"/>
                                    {errors.certNum && <p role="alert" className="alertRed">{errors.certNum.message}</p>}
                                    <p className="cRed">{formatTime()}</p>
                                    <button type="button" onClick={fn_certNum} className="btn40 cFFF navyB">{t(`Message.change_member_info_certification`)}</button>
                                </div>
                                ):null}
                            </div>
                            )}
                        </li>
                        <li className="idLi">
                            <p>혜택정보 및 광고 수신 동의</p>
                            <ul className="chkWr">
                                <li>
                                    <input type="checkbox" name="a" id="a1" ref={smsRecptnAgreAt} defaultChecked={data.smsRecptnAgreAt === 'Y'}   onChange={(e)=> fn_changeAgree(e,'sms')} />
                                    <label htmlFor="a1">{t(`Message.sign_up_agree_check_sms_acceptance`)}</label>
                                </li>
                                <li>
                                    <input type="checkbox" name="b" id="a2"  ref={emailRecptnAgreAt} defaultChecked={data.emailRecptnAgreAt === 'Y'} onChange={(e)=> fn_changeAgree(e,'email')}  />
                                    <label htmlFor="a2">{t(`Message.sign_up_agree_check_accept_email`)}</label>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div className="dfce mt40">
                        <Link to="/DeleteAccount" className="cDisa">{t(`Message.change_member_info_withdrawal`)}</Link>
                    </div>
                </form>
            </div>
            )}
        </div>
    );
};